// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input::-ms-clear,input::-ms-reveal{display:none!important}::-webkit-scrollbar{width:8px;height:8px}::-webkit-scrollbar-track{border-radius:8px;background:#f5f5f5}::-webkit-scrollbar-thumb{width:5px;background:#e4e7ed}::-webkit-scrollbar-thumb:hover{background:#adadad}", ""]);
// Exports
module.exports = exports;
